<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as SUPPLIER_CONTACT_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ContactTableMixin from '../../../components/contact/mixins/ContactTableMixin'

export default {
  name: 'SupplierContactTable',
  mixins: [ContactTableMixin],
  created () {
    if (!this.params.orgId) {
      delete (this.fields[6])
      delete (this.fields[8])
      delete (this.fields[10])
      delete (this.fields[11])
      delete (this.fields[12])
    }
  },
  computed: {
    ...mapGetters({
      selectAll: SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.GETTERS.selectAll,
      selectedList: SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.GETTERS.selectedList
    }),
    showDetailButton () {
      return hasPerm('organization_suppliercontact_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.MUTATIONS.setList,
      setSelectedList:
        SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.MUTATIONS.setSelectedList,
      setSelectAll: SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...SUPPLIER_CONTACT_TYPES.GENERIC.organization.suppliercontact.LIST.ACTIONS
    })

  }
}
</script>
